<div class="flex flex-column justify-center align-center h-100 text-center family-info">
  <div class="modal-icon">
    <img src="../../../../assets/images/svgs/alert.svg" alt="ICON" />
  </div>
  <h1 class="para-title">Transparency Disclaimer</h1>
  <p class="para-body">
    We neither receive money directly from donors nor give funds directly to families. We only provide a connection between both parties in a transparent way. 
  </p>

  <button class="ui button primary basic mt-4" (click)="continue()">Continue</button>
</div>